import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import dayjs from "dayjs"; 

//internal import
import PageHeader from "../../components/common/PageHeader";
import useHolidaySubmit from "../../hooks/useHolidaySubmit";
import InputArea from "../../components/Input/InputArea";
import Error from "../../components/Input/Error";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import HolidayService from "../../services/HolidayService";
import DropDownService from "../../services/DropDownService";
import { useLocation } from 'react-router-dom';

function Holidays() {

    const [holidayId, setHolidayId] = useState("");

    const { data, loading } = useAsync(() => HolidayService.getAllHoliday());
    const location = useLocation();
    const { pathname } = location; 
    const { data:permissionData } = useAsync(() => DropDownService.getModulePermissions({ path:pathname, userId:localStorage.id})); 
    var addPermission = typeof permissionData?.data?.add === 'undefined' ? 1: permissionData?.data?.add; 
    var viewPermission = typeof permissionData?.data?.view === 'undefined' ? 1: permissionData?.data?.view;
    var editPermission = typeof permissionData?.data?.edit === 'undefined' ? 1: permissionData?.data?.edit; 
    var deletePermission = typeof permissionData?.data?.delete === 'undefined' ? 1: permissionData?.data?.delete; 
    var listPermission = typeof permissionData?.data?.list === 'undefined' ? 1: permissionData?.data?.list;
 
    const {
        register,
        handleSubmit,
        errors,
        onSubmit,
        handleDeleteHoliday,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        viewData } = useHolidaySubmit(holidayId);

    var columnsT = "";

    columnsT = [
        {
            name: "HOLIDAY NAME",
            selector: row => <b className={row.holidayName}>{row.holidayName}</b>,
            sortable: true
        },
        {
            name: "HOLIDAY DATE",
            selector: row => <span className={row.txtClass}>{dayjs(row.holidayDate).format("DD-MM-YYYY")}</span>,
            sortable: true
        },
        {
            name: "ACTION",
            selector: () => { },
            sortable: true,
            cell: (row) => (<div className="btn-group" role="group" aria-label="Basic outlined example">
                {viewPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsViewModal(true); setHolidayId(row?._id) }} ><i className="icofont-eye-alt text-primary"></i></button>)}
                {editPermission === 1 && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsModal(true); setHolidayId(row?._id); }}><i className="icofont-edit text-success"></i></button>)}
                {deletePermission === 1 && (<button type="button" className="btn btn-outline-secondary deleterow" onClick={() => { setIsDeleteModal(true); setHolidayId(row?._id) }} ><i className="icofont-ui-delete text-danger"></i></button>)}
            </div>)
        }

    ]
    return (
        <div className="container-xxl">

            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader addPermission={addPermission} headerTitle="Holiday" renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                            <button className="btn btn-dark btn-set-task w-sm-100 me-2" onClick={() => { setIsModal(true); setHolidayId(""); }}><i className="icofont-plus-circle me-2 fs-6"></i>Add Holiday</button>
                        </div>
                    }} />
                    {listPermission === 1 && (
                    <div className="row clearfix g-3">
                        <div className="card">
                            <div className="card-body">
                                <DataTable
                                    title={"Holidays"}
                                    columns={columnsT}
                                    data={data.data}
                                    defaultSortField="title"
                                    pagination
                                    selectableRows={false}
                                    className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                    highlightOnHover={true}
                                />
                            </div>
                        </div>
                    </div>
                    )}
                </>
            }

            {/* holiday view modal */}
            <Modal show={isViewModal} size="lg" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Holidays Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="modal-body">
                        <div className="deadline-form">
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Holiday Name </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.holidayName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Holiday Date </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{dayjs(viewData?.holidayDate).format("DD-MM-YYYY")}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* holiday add and edit modal */}
            <Modal centered show={isModal} onHide={() => { setIsModal(false)}}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{holidayId ? "Edit" : "Add"} Holiday</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label className="form-label">Holiday Name</label>
                            <InputArea register={register} label={"Name"} name="holidayName" type="text" className="form-control" id="exampleFormControlInput1" placeholder="Holiday Name" />
                            <Error errorName={errors?.holidayName} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Holiday Date</label>
                            <InputArea register={register} name="holidayDate" type="date" className="form-control" id="exampleFormControlInput2778"  />
                            <Error errorName={errors?.holidayDate} />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">{holidayId ? "Update " : "Add"}</button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* holiday delete modal */}
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete Holiday</Modal.Title>
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete Holiday ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => handleDeleteHoliday(holidayId)}>Delete</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}


export default Holidays;